import { render, staticRenderFns } from "./comp_DeliveryOptionContent-PickupPoint.vue?vue&type=template&id=38bffb1b"
import script from "./comp_DeliveryOptionContent-PickupPoint.vue?vue&type=script&lang=js"
export * from "./comp_DeliveryOptionContent-PickupPoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports